import React from 'react';
import { NavItemType } from '../../../types';
import { AttendeeCreatorToggle } from '../AttendeeCreatorToggle';
import { IntentToggleOptions } from '../AttendeeCreatorToggle/AttendeeCreatorToggle';
import { MobileDropdown } from '../Dropdowns';
import styles from './IntentToggle.module.scss';

interface IntentToggleProps {
    activeOption: IntentToggleOptions;
    dropdownItems: NavItemType[];
    isMobile?: boolean;
}

export const IntentToggle: React.FC<IntentToggleProps> = ({
    activeOption,
    dropdownItems,
    isMobile = false,
}) => {
    const containerClass = isMobile
        ? styles.mobileToggleContainer
        : styles.toggleContainer;

    if (isMobile) {
        return (
            <div className={styles.mobileContainer}>
                <div className={containerClass}>
                    <AttendeeCreatorToggle activeOption={activeOption} />
                </div>
                <div className={styles.mobileDropdownContainer}>
                    <MobileDropdown dropdownItems={dropdownItems} />
                </div>
            </div>
        );
    }

    return (
        <>
            <div className={containerClass}>
                <AttendeeCreatorToggle activeOption={activeOption} />
            </div>
            <MobileDropdown dropdownItems={dropdownItems} />
        </>
    );
};
